/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_SneakerInputs */

const en_landing_showcase_sneaker = /** @type {(inputs: Landing_Showcase_SneakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product shot`)
};

const zh_landing_showcase_sneaker = /** @type {(inputs: Landing_Showcase_SneakerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品摄影`)
};

/**
* | output |
* | --- |
* | "Product shot" |
*
* @param {Landing_Showcase_SneakerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_sneaker = /** @type {((inputs?: Landing_Showcase_SneakerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_SneakerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_sneaker(inputs)
	return zh_landing_showcase_sneaker(inputs)
});
export { landing_showcase_sneaker as "landing.showcase.sneaker" }